import React from "react"
import axios from "axios"
import { API } from "../../API";
import { connect } from "react-redux"
import { notify } from "react-notify-toast"
import { PORT } from "../../config"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import BankDetailsForm from "./BankDetailsForm"
import { debounce } from 'lodash'

const initialState = {
  account_name: "",
  bsb: "",
  bank_name: "",
  account_number: "",
  account_no_disabled: false,
  show_popup: false
}

class BankDetails extends React.Component {
  state = initialState;

  componentDidMount() {
    // disabling this for now
    //   if (!this.props.user.bank_details_enabled) {
    //     notify.show("This page is not enabled for you yet.");
    //     this.props.history.push("/Home2");
    //   }

    API.getSafeBankData()
      .then(res => {
        // console.log(res.data)
        if (res.data.bank_details) {
          const { account_name, bank_name, bsb, account_number } = res.data.bank_details;
          this.setState({
            account_name, bank_name, bsb,
            account_number: account_number ? ("XXXXX" + account_number) : "",
            account_no_disabled: account_number ? true : false
          });
        }
      })
  }

  handleStateChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  handleDebounceStateChange = debounce(e => {
    const regex = /[^A-Za-z0-9]/;
    if(regex.test(e.target.value)) {
      notify.show("Please remove any spaces or special characters and click Submit")
    }
  }, 500)

  togglePopup = () => {
    this.setState({ show_popup: !this.state.show_popup })
  }

  handleSubmit = (e) => {
    const regex = /[^A-Za-z0-9]/;
    if(regex.test(this.state.account_number)) {
      notify.show("Please remove any spaces or special characters and click Submit")
    }
    e.preventDefault()
    const fields = [
      "account_name",
      "bank_name",
      "bsb",
      "account_number",
      "declaration_check"
    ]
    let errors = false

    for (let field of fields) {
      const input = document.getElementById(field)
      if (!input.reportValidity()) {
        errors = true
        break;
      }
    }

    if (!errors) {
      API.updateBankData({
        // email: this.props.user.email,
        account_name: this.state.account_name,
        bsb: this.state.bsb,
        bank_name: this.state.bank_name,
        account_number: this.state.account_no_disabled ? null : this.state.account_number,
      })
        .then((res) => {
          notify.show("Banking details saved successfully")
          this.setState({ account_no_disabled: true })

          // Email notification
          API.sendTeacherProfileProgressEmail({
            _id: this.props.user._id,
            to: this.props.user.email,
            first_name: this.props.user.first_name,
            etype: "BANK_CONF",
          }).then((result) => {
              console.log('result:', result)
            })
            .catch((err) => {
              console.log('err:', err)
            })
        })
        .catch((err) => {
          console.error()
          notify.show("Error saving bank details", "error")
        })
    }
  }

  handleDelete = () => {
    API.deleteBankData().then(res => {
      notify.show("Bank details deleted successfully")
      this.setState(initialState)
    })
      .catch(err => {
        console.error()
        notify.show("Error deleting bank details", "error")
      })
  }

  tabs = [
    {
      pathname: "/BankDetails",
      text: "Bank Details",
      active: true,
    },
    {
      pathname: "/Tax",
      text: "Tax Declaration",
    },
    {
      pathname: "/Superannuation",
      text: "Superannuation",
    },
  ]

  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Payments"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
        >
          <BankDetailsForm
            onChange={this.handleStateChange}
            onDelete={this.handleDelete}
            togglePopup={this.togglePopup}
            state={this.state}
            handleDebounceStateChange={this.handleDebounceStateChange}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return { user: state.user.user }
}

export default connect(mapStateToProps)(BankDetails)
